const videoEl = '.kb-fullscreen-takeover__video'
const playButtonEl = '.kb-fullscreen-takeover__play'
const ctaEl = '.kb-fullscreen-takeover__cta'
const stageEl = '.kb-fullscreen-takeover__stage'
const outroEl = '.kb-fullscreen-takeover__outro'
const outroCloseEl = '.kb-fullscreen-takeover__outro-close'
const hiddenClass = 'kb-fullscreen-takeover__hidden'
const outroHiddenClass = 'kb-fullscreen-takeover__outro--hidden'
const shareEl = '.kb-fullscreen-takeover__share'
const nativeShareLinkEl = 'a[data-native-share]'

// The Facebook and LinkedIn apps hijack their share links on mobile and drop the shared URL
const initNativeShare = () => {
    const share = document.querySelector(shareEl)
    const isTouchDevice = window.matchMedia('(pointer: coarse)').matches
    if (!share || !navigator.share || !isTouchDevice) return

    const { shareUrl: url, shareTitle: title } = share.dataset

    share.querySelectorAll(nativeShareLinkEl).forEach((link) => {
        link.addEventListener('click', (event) => {
            event.preventDefault()
            navigator.share({ title, url }).catch((error) => {
                if (error.name !== 'AbortError') window.open(link.href, '_blank', 'noopener')
            })
        })
    })
}

export default function () {
    window.addEventListener('pageshow', (event) => {
        if (event.persisted) window.location.reload()
    })

    initNativeShare()

    const videos = [...document.querySelectorAll(videoEl)]

    if (!videos.length) return

    const playButton = document.querySelector(playButtonEl)
    const playTarget = playButton ? playButton.closest(ctaEl) || playButton : null
    const outro = document.querySelector(outroEl)
    const isLoop = videos[0].hasAttribute('autoplay')
    let started = false
    let outroDismissed = false

    const showCta = () => playTarget && playTarget.classList.remove(hiddenClass)
    const hideCta = () => playTarget && playTarget.classList.add(hiddenClass)
    const isVisible = (video) => video.offsetParent !== null
    const visibleVideo = () => videos.find(isVisible) || videos[0]

    const stage = document.querySelector(stageEl)
    const syncStageRatio = () => {
        const video = visibleVideo()
        if (!stage || !video.videoWidth) return
        stage.style.setProperty('--kb-takeover-ratio', `${video.videoWidth} / ${video.videoHeight}`)
    }

    // Pages opened from an access link hold the source back until play, since the first video request spends the link
    const loadDeferredSource = (video) => {
        if (video.dataset.src && !video.getAttribute('src')) video.src = video.dataset.src
    }

    const play = (video) => {
        loadDeferredSource(video)
        if (!isLoop) video.controls = true
        return video.play()
    }

    const handOver = () => {
        if (isLoop) {
            if (visibleVideo().paused) autoplay()
            return
        }

        if (!started) return

        const from = videos.find((video) => !isVisible(video) && video.currentTime > 0)
        const to = visibleVideo()
        if (!from || from === to) return

        const wasPlaying = !from.paused
        from.pause()
        loadDeferredSource(to)
        to.currentTime = from.currentTime
        to.controls = true
        if (wasPlaying) to.play().catch(() => {})
    }

    syncStageRatio()
    window.addEventListener('resize', syncStageRatio)

    videos.forEach((video) => {
        video.addEventListener('loadedmetadata', syncStageRatio)
        video.addEventListener('ended', () => {
            if (!outro || outroDismissed) {
                showCta()
                return
            }

            hideCta()
            outro.classList.remove(outroHiddenClass)
        })

        video.addEventListener('playing', hideCta)
        video.addEventListener('contextmenu', (event) => event.preventDefault())

        if (isLoop) {
            video.addEventListener('playing', () => { video.controls = false })
            // Browsers pause or refuse the hidden (display: none) video, so only the visible one may show the CTA
            video.addEventListener('pause', () => {
                if (video === visibleVideo()) showCta()
            })
        }
    })

    const autoplay = () => {
        const visible = visibleVideo()
        videos.forEach((video) => {
            if (video !== visible) {
                video.pause()
                return
            }

            video.muted = true
            video.play().catch(() => {
                if (!playTarget) video.controls = true
                showCta()
            })
        })
    }

    const reset = () => {
        started = false
        videos.forEach((video) => {
            video.pause()
            video.currentTime = 0
            video.controls = false
        })
        if (outro) outro.classList.add(outroHiddenClass)
        showCta()
    }

    if (isLoop) {
        autoplay()
        // Mobile browsers pause video while the page is in the background
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden && visibleVideo().paused) autoplay()
        })
    }

    const outroClose = document.querySelector(outroCloseEl)
    if (outroClose) outroClose.addEventListener('click', () => {
        outroDismissed = true
        reset()
    })

    if (videos.length > 1) {
        const observer = new ResizeObserver(handOver)
        videos.forEach((video) => observer.observe(video))
    }

    if (!playButton) return

    playButton.addEventListener('click', () => {
        started = true
        play(visibleVideo()).catch(() => {})
    })
}
